import { createSlice} from "@reduxjs/toolkit";

const initialState = {
    toggle_language: false,
};

export const LanguageSlice = createSlice({
    name: 'language',
    initialState:initialState,
    reducers: {
        saveLanguageWeb: (state, action) => {
            state.toggle_language = action.payload
        },
    },
});


export const {saveLanguageWeb} = LanguageSlice.actions;
export default LanguageSlice.reducer